import React from "react";
import SensorBase from "./SensorBase";

const FIELD = "vpd";
const UNIT = "kPa";

const Vpd: React.FC = () => {
  return (
    <SensorBase field={FIELD} unit={UNIT}></SensorBase>
  );
};

export default Vpd;
